import React from "react";
import { HashRouter  as Router, Routes, Route, Link } from "react-router-dom";
import "../CSS/Footer.css";
import designerImage from "../Resources/Images/G.png";



const Navbar: React.FC = () => {
  return (
    <nav>
      <section className="contactMe">
        <div className="contactMebordercenter">
          <div className="contactTopic">
            <p>Let's Connect</p>
            <div className="TopicBorder"></div>
          </div>
          
          <div className="contactFormContainer">
            <form className="contactForm">
              <div className="formGroup">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" placeholder="Enter your name" required />
              </div>
              
              <div className="formGroup">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" placeholder="Enter your email" required />
              </div>

              <div className="formGroup">
                <label htmlFor="message">Message</label>
                <textarea id="message" placeholder="Write your message" required></textarea>
              </div>

              <button type="submit" className="submitBtn">Send Message</button>
            </form>
          </div>

          <div className="contactDetails">
            <p><strong>Email:</strong> reidenrealm@gmail.com</p>
            <p><strong>Phone:</strong> +94 71 790 3582</p>
          </div>
        </div>
      </section>

      <section className="footer">
        <div className="footerboarderCenter">
          
        </div>
      </section>
      <div className="footerNav">
      <img className="designerImage" src={designerImage} alt="Designer" />
      
        <div className="navigationSection">
          <ul className="navigationSectionList">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/About">About</Link></li>
            <li><Link to="/Contact">Contact</Link></li>
          </ul>
        </div>
        <p>Copyright © 2025 ReidenRealm</p>
      </div>
    </nav>
  );
};
export default Navbar;